import React, { FC, useMemo } from 'react';
import { useMergeClasses } from '@websky/core/src/theme';
import { useTranslation } from 'react-i18next';

import { useConfig } from '@websky/core/src/context';

import classes from './FirstLoginAgreement.css';

import { AgreementCheckboxType } from '@websky/core/src/AgreementCheckboxWrapper';
import FirstLoginAgreementBase, {
	Props
} from '@websky/core/src/LoginPage/components/LoginForm/FirstLoginAgreement/FirstLoginAgreement';

const FirstLoginAgreement: FC<Props> = ({ classes: propsClasses, ...props }) => {
	const css = useMergeClasses(propsClasses, classes);

	const { t } = useTranslation('LoginPage');

	const {
		global: { companyInfo }
	} = useConfig();

	const checkboxes = useMemo<AgreementCheckboxType[]>(() => {
		const defaultCheckboxes: AgreementCheckboxType[] = [
			{
				fieldName: 'agreement_1',
				label: (
					// TODO: заменить на SafeHtml после вливания задачи WEBSKY-7486
					<span
						className={css.checkbox__label}
						dangerouslySetInnerHTML={{
							__html: t('N4_FirstLoginAgreement_Checkbox_Label_1')
						}}
					/>
				),
				required: true
			},
			{
				fieldName: 'agreement_2',
				label: (
					// TODO: заменить на SafeHtml после вливания задачи WEBSKY-7486
					<span
						className={css.checkbox__label}
						dangerouslySetInnerHTML={{
							__html: t('N4_FirstLoginAgreement_Checkbox_Label_2')
						}}
					/>
				),
				required: true
			}
		];

		return defaultCheckboxes;
	}, [t, companyInfo]);

	return <FirstLoginAgreementBase {...props} classes={css} checkboxes={checkboxes} />;
};

export default FirstLoginAgreement;
